var React = require('react');

function Analytics (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m31.914 5.789-5.958 4.768c.021.146.044.291.044.443a3 3 0 1 1-6 0c0-.152.023-.298.044-.444l-5.959-4.767A2.974 2.974 0 0 1 12.999 6a3 3 0 0 1-.768-.111l-6.344 6.344c.065.246.111.501.111.768a3 3 0 1 1-3-3 3 3 0 0 1 .768.111l6.344-6.344A2.993 2.993 0 0 1 9.999 3a3 3 0 1 1 6 0c0 .152-.023.298-.044.444l5.958 4.766c.338-.132.702-.211 1.086-.211s.749.079 1.086.211l5.959-4.767C30.023 3.297 30 3.152 30 3a3 3 0 1 1 3 3c-.384 0-.748-.079-1.086-.211zM25 20a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V21a1 1 0 0 1 1-1h4zm10-8a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h4zm-20 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h4zM5 22a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h4z"}));
}

Analytics.defaultProps = {"viewBox":"0 0 36 32"};

module.exports = Analytics;

Analytics.default = Analytics;
